import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset, palette } from '@primeuix/themes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID } from '@angular/core';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { MSAL_INSTANCE, MsalService, MsalBroadcastService} from '@azure/msal-angular';
import { PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from '../environments/environment';

// Registra os dados de formatação para o português
registerLocaleData(localePt);

const AuraIndigo = definePreset(Aura, {
  semantic: {
    primary: palette('{gray}')
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' }, // Define o português como padrão para datas e números
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({  theme: { preset: AuraIndigo , options: { darkModeSelector: false} }  }),
    provideHttpClient(),
    {
      provide: MSAL_INSTANCE,
      useFactory: () => new PublicClientApplication({
        auth: {
          clientId: 'b13123d4-19c2-48bf-8486-3454a1477087',
          authority: 'https://login.microsoftonline.com/common',
          redirectUri: environment.Url.MSAL
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage
        }
      })
    },
    MsalService,
    MsalBroadcastService
  ]
};